import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

class DepartmentMemberStore extends ReduceStore {

    getInitialState() {
        return {isFetching: false, fetchedAll: false, members: {}};
    }

    isFetching() {
        return this.getState().isFetching;
    }

    fetchedAll() {
        return this.getState().fetchedAll;
    }

    getMembers(id) {
        return this.getState().members[id];
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.DEPARTMENT_MEMBERS_LIST_REQUEST:
                return update(this.getState(), { isFetching: { $set: true }});

            case ActionTypes.DEPARTMENT_MEMBERS_LIST_SUCCESS:
                return update(this.getState(), {
                    isFetching: { $set: false },
                    fetchedAll: { $set: action.data.length === 0 },
                    members: {
                        [action.payload.id]: {
                            $set: action.payload.clearAll ? action.data : [...this.getState().members[action.payload.id], ...action.data]
                        }
                    }
                });

            case ActionTypes.DEPARTMENT_MEMBERS_LIST_FAILURE:
                return update(this.getState(), { isFetching: { $set: false } });

            default:
                return state;
        }
    }
}

export default new DepartmentMemberStore(CentricDispatcher);
